import "./LoginSection.scss";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { LeftArrowIcon } from "../../assets/icons";
import panoramica from "../../assets/images/panoramica.jpg";
import config from "../../config";
import { useThemedAssets } from "../../helpers/themeAssets";

function LoginSection() {
  const navigate = useNavigate();
  const { logoFull } = useThemedAssets();
  localStorage.removeItem("cbcValue");
  localStorage.removeItem("AREA_SCAVO");
  return (
    <section className="login-page-container ">
      <img src={config.customerLogo || logoFull} alt="logo Amministrazione" className="customer-logo" />
     {/*} <p className="login-title">{config.title}</p> */}
      <p className="login-description">
        {config.description}
      </p>
      <div className="intro-image-frame1">
        <div className="intro-image-frame2">
          <img src={panoramica} alt="panoramica" className="intro-image" />
        </div>
      </div>

      <button onClick={() => navigate("/signin")} className="login-button">
        <span className="login-text">Accedi</span>
        <LeftArrowIcon />
      </button>

      <div className="loghi-finanziamento-image-frame1">
        <div className="loghi-finanziamento-image-frame2">
          <img src={config.loghiFinanziamento} alt="loghi finanziamento" className="loghi-finanziamento" />
        </div>
      </div>

    </section>
  );
}

export default LoginSection;
